import {
	PanelBody,
	ToggleControl,
	RangeControl,
	TextControl,
} from '@wordpress/components';
import { __ } from '@wordpress/i18n';

/**
 * Axes and grid.
 *
 * Radial charts have no axes, so this panel does not render for them at all
 * rather than showing controls that change nothing.
 */
export default function AxisControls( { attributes, setAttributes } ) {
	return (
		<PanelBody
			title={ __( 'Axes & grid', 'brandy-blocks' ) }
			initialOpen={ false }
		>
			<ToggleControl
				__nextHasNoMarginBottom
				label={ __( 'Gridlines', 'brandy-blocks' ) }
				checked={ !! attributes.showGrid }
				onChange={ ( value ) => setAttributes( { showGrid: value } ) }
			/>
			<ToggleControl
				__nextHasNoMarginBottom
				label={ __( 'Value axis', 'brandy-blocks' ) }
				help={ __(
					'The ticks carry every value you did not label directly. Keep them unless the chart labels all of them.',
					'brandy-blocks'
				) }
				checked={ !! attributes.showValueAxis }
				onChange={ ( value ) =>
					setAttributes( { showValueAxis: value } )
				}
			/>
			<ToggleControl
				__nextHasNoMarginBottom
				label={ __( 'Category axis', 'brandy-blocks' ) }
				checked={ !! attributes.showCategoryAxis }
				onChange={ ( value ) =>
					setAttributes( { showCategoryAxis: value } )
				}
			/>
			<ToggleControl
				__nextHasNoMarginBottom
				label={ __( 'Angle the category labels', 'brandy-blocks' ) }
				help={ __(
					'Use when long names would collide.',
					'brandy-blocks'
				) }
				checked={ !! attributes.rotateCategoryLabels }
				onChange={ ( value ) =>
					setAttributes( { rotateCategoryLabels: value } )
				}
			/>

			<RangeControl
				__nextHasNoMarginBottom
				label={ __( 'Tick count', 'brandy-blocks' ) }
				value={ attributes.tickCount }
				min={ 2 }
				max={ 10 }
				onChange={ ( value ) =>
					setAttributes( { tickCount: value ?? 5 } )
				}
			/>

			<TextControl
				__nextHasNoMarginBottom
				type="number"
				label={ __( 'Axis minimum', 'brandy-blocks' ) }
				help={ __(
					'Leave empty to fit the data. Bars and areas always include zero, because a bar measured from anything else misstates its own length.',
					'brandy-blocks'
				) }
				value={ attributes.axisMin }
				onChange={ ( value ) => setAttributes( { axisMin: value } ) }
			/>
			<TextControl
				__nextHasNoMarginBottom
				type="number"
				label={ __( 'Axis maximum', 'brandy-blocks' ) }
				value={ attributes.axisMax }
				onChange={ ( value ) => setAttributes( { axisMax: value } ) }
			/>
		</PanelBody>
	);
}
